const OSS = require('ali-oss')
const ffmpeg = require('fluent-ffmpeg');
const SparkMD5 = require('spark-md5')
import { getOssSts } from '@/api/data'

// 获取STS客户端（用于temp-aidoohiky bucket）
async function getClientId() {
  try {
    const res = await getOssSts()
    if (res.data.code === 200) {
      const stsData = res.data.data
      return new OSS({
        region: 'oss-cn-shenzhen',
        accessKeyId: stsData.accessKey,
        accessKeySecret: stsData.accessKeySecret,
        stsToken: stsData.token,
        bucket: 'temp-aidoohiky',
        secure: true,
        timeout: 6000000
      })
    }
    throw new Error('获取STS token失败')
  } catch (error) {
    console.error('获取STS token失败:', error)
    throw error
  }
}

// 获取STS客户端（用于temp-aidoohiky bucket）
async function getClient() {
  try {
    const res = await getOssSts()
    if (res.data.code === 200) {
      const stsData = res.data.data
      return new OSS({
        region: 'oss-cn-shenzhen',
        accessKeyId: stsData.accessKey,
        accessKeySecret: stsData.accessKeySecret,
        stsToken: stsData.token,
        bucket: 'temp-aidoohiky',
        secure: true,
        timeout: 6000000
      })
    }
    throw new Error('获取STS token失败')
  } catch (error) {
    console.error('获取STS token失败:', error)
    throw error
  }
}

async function upload(client, path, file){
    const result = await client.put(path, file);

    if (result['res']['statusCode'] == 200){
        return result['res']['requestUrls'][0]
    }
    
    return ""
}

function getVideoResolvingPowerMethod(videoPath){
    // 使用fluent-ffmpeg获取视频信息
    ffmpeg.ffprobe("sl.mp4", (err, metadata) => {
        if (err) {
        console.error(`获取视频信息失败: ${err.message}`);
        return;
        }
    
        // 获取宽度
        const width = metadata.streams[0].width;
        const height = metadata.streams[0].height;
        console.log(`视频宽度: ${width}`);
        console.log(`视频高度: ${height}`);
    });
}

export const uploadIdFile  = async (path, file) => {
    const clientId = await getClientId()
    return await upload(clientId, path, file)
}

export const uploadFile = async (path, file) => {
    const client = await getClient()
    return await upload(client, path, file)
}

export const getVideoResolvingPower = (path) => {
    return getVideoResolvingPowerMethod(path)
}

export const getTimeDifference = (originalTime) => {

    if (originalTime == null || originalTime == '')
      return ""
  
    originalTime = new Date(originalTime.replace(/-/g, '/'));
    const now = new Date();
    const differenceInMs = now - originalTime;
    const differenceInMinutes = Math.floor(differenceInMs / (1000 * 60));
    const differenceInHours = Math.floor(differenceInMinutes / 60);
    const differenceInDays = Math.floor(differenceInHours / 24);
  
    if (differenceInDays > 3) {
      // 超过3天，显示原始时间
      return `${originalTime.toLocaleString()}`;
    } else if (differenceInDays > 1) {
      // 超过1天但不超过3天，显示为“x天前”
      return `${differenceInDays}天前`;
    } else if (differenceInHours > 1) {
      // 超过1小时但不超过1天，显示为“x小时前”
      return `${differenceInHours}小时前`;
    } else if (differenceInMinutes > 1) {
      // 超过1分钟但不超过1小时，显示为“x分钟前”
      return `${differenceInMinutes}分钟前`;
    } else {
      // 少于1分钟，显示为“刚刚”
      return '刚刚';
    }
  }



export const  calculateFileMd5 = async (file) => {
  return new Promise((resolve, reject) => {
    const chunkSize = 2097152; // 2MB
    const chunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    const spark = new SparkMD5.ArrayBuffer();
    const fileReader = new FileReader();

    fileReader.onload = function (e) {
      spark.append(e.target.result); // Append array buffer
      currentChunk++;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        const md5 = spark.end();
        resolve(md5);
      }
    };

    fileReader.onerror = function () {
      reject('File read error');
    };

    function loadNext() {
      const start = currentChunk * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      fileReader.readAsArrayBuffer(file.slice(start, end));
    }

    loadNext();
  });
}



